import { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CmsPagesQueryObject {
  getCmsPages: {
    items: {
      active: boolean
      id: boolean
      identifier: boolean
      title: boolean
      meta_title: boolean
      meta_keywords: boolean
      meta_description: boolean
      content_heading: boolean
      content: boolean
      sort_order: boolean
      pwa_layout: boolean
    }
  }
}

export const cmsPagesQueryObject = {
  getCmsPages: {
    items: {
      active: true,
      id: true,
      identifier: true,
      title: true,
      meta_title: true,
      meta_keywords: true,
      meta_description: true,
      content_heading: true,
      content: true,
      sort_order: true,
      pwa_layout: true
    }
  }
}

export type GetCmsPagesQuery = () => Promise<AxiosResponse<any>>

export const createGetCmsPagesQuery = ({ getQueries }: ServiceDependencies): GetCmsPagesQuery => async () => {
  const query = getQueries().getCmsPagesQuery

  return axiosClient(jsonToGraphQLQuery(query), true)
}
